const SPACE_STATE = {
    Occupied: 'occupied',
    LateRent: 'laterent',
    Vacant: 'vacant',
    Maintenance: 'maintenance'
};

var BuildingStatistics = Class.create({
    initialize: function() {
        this.totalSpaces = 0;
        this.totalOccupied = 0;
        this.totalLateRent = 0;
        this.totalVacant = 0;
        this.totalMaintenance = 0;
        this.totalDoorsOpened = 0;
        this.totalDoorsClosed = 0;
    },
    determineStatistics: function(data, callback) {
        var totalSpaces = 0, totalVacant = 0, totalOccupied = 0, totalLateRent = 0, totalLevels = 0, totalMaintenance = 0, totalDoorsOpened = 0, totalDoorsClosed = 0;
        data.forEach(level => {
            const levelData = level.data;
            if(levelData.spaces !== undefined) {
                const spaces = levelData.spaces;
                var totalFloorSpaces = 0;
                spaces.forEach(space => {
                    if(space.space_data.space_abbreviation == 'doorsensor' || space.space_data.space_abbreviation == 'watersensor'
                    || space.space_data.space_abbreviation == 'firealarm' || space.space_data.space_abbreviation == 'tempsensor') {
                    } else {
                        totalFloorSpaces++;
                    }
                });
                totalSpaces += totalFloorSpaces;
                if(levelData.active_state) {
                    // determine total vacant/occupied/laterent
                    spaces.forEach(space => {
                        if(space.space_color_coding) {
                            if(space.space_color_coding.color_alias_name == SPACE_STATE.Vacant) {
                                ++totalVacant;
                            } else if(space.space_color_coding.color_alias_name == SPACE_STATE.LateRent) {
                                ++totalLateRent;
                            } else if(space.space_color_coding.color_alias_name == SPACE_STATE.Occupied) {
                                ++totalOccupied;
                            } else if(space.space_color_coding.color_alias_name == SPACE_STATE.Maintenance) {
                                ++totalMaintenance;
                            }
                        }
                    });
                } else {
                    totalVacant += totalFloorSpaces;
                }
            }
        });
        this.totalSpaces = totalSpaces;
        this.totalVacant = totalVacant;
        this.totalOccupied = totalOccupied;
        this.totalLateRent = totalLateRent;
        this.totalMaintenance = totalMaintenance;
        this.totalDoorsOpened = totalDoorsOpened;
        this.totalDoorsClosed = totalDoorsClosed;

        if(callback) {
            callback();
        }
    }
});

export let buildingStatistics = new BuildingStatistics();


// WEBPACK FOOTER //
// app/helpers/Building/BuildingStatistics.js